import { render, staticRenderFns } from "./ActionProducts.vue?vue&type=template&id=3613ca26&scoped=true&"
import script from "./ActionProducts.vue?vue&type=script&lang=js&"
export * from "./ActionProducts.vue?vue&type=script&lang=js&"
import style0 from "./ActionProducts.vue?vue&type=style&index=0&id=3613ca26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3613ca26",
  null
  
)

export default component.exports